<script>
import PftPlageSelector from "@/containers/pft-plage-selector";
import RateStar from "@/components/atoms/rate-star";
import Price from "@/components/molecules/price";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import Divider from "@/components/atoms/divider";
import Badge from "@/components/atoms/badge";
import EnergyClass from "@/components/molecules/energy-class";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import NutriScore from "@/components/molecules/nutri-score";
import LinkTo from "@/components/atoms/link-to";
import PopinTraiteurDeFetes from "@/containers/popin-traiteur-de-fetes";
import PopinTraiteurPermanent from "@/containers/popin-traiteur-permanent";
import BadgeBoutique from "@/containers/badge-boutique";
import CarteKdoMontant from "@/components/organisms/product-sheet/carte-kdo-montant";
import Titre from "@/components/atoms/titre";

import ProductDetailsVariant from "@/containers/product-sheet/product-details-variant";
import ImageProductViewer from "@/components/organisms/product-sheet/image-product-viewer/mobile";
import productFeaturesCodes from "@/utils/product-features-codes";
import ItemContainer from "@/containers/panier/item";
import ButtonIcon from "@/components/molecules/button-icon";
import AdvantagesContainer from "@/containers/avantages";
import ShippingMethodEligibility from "@/containers/shipping-method-eligibility";
import IndiceReparabilite from "@/components/molecules/indice-reparabilite";
import BandeauTraiteurFete from "@/components/organisms/merch-traiteur-fete/bandeau-fp-mobile";
import BandeauTraiteurPermanent from "@/components/organisms/merch-traiteur-permanent/bandeau-fp";
import ReassuranceDLC from "@/components/organisms/reassurance-dlc";
import Popin from "@/components/molecules/popin";
import Alert from "@/components/molecules/alert";
import CmsFetcher from "@/containers/cms-fetcher";
import ProductDetailsMultipay from "@/containers/product-sheet/product-details-multipay";
import PrixRemise from "@/containers/prix-remise";
import BadgePoids from "@/components/molecules/badge-poids";
import { useProductSheetBreadcrumb } from "../mixins/product-sheet-breadcrumb.mixin";
import { useProductListItem } from "@/components/organisms/mixins/product-list-item-mixin";
import {
  productDetailsEmits,
  productDetailsProps,
  useProductDetails
} from "./mixin";

import alertShippingLad from "@/assets/images/livraison/ldd/alert-shipping-lad.svg";
import primeEnergie from "@/assets/images/prime-energie.png";
import consigne from "@/assets/images/Consigne@2x.png";

export default {
  name: "ProductDetails",
  components: {
    Icon,
    PftPlageSelector,
    List,
    LinkTo,
    NutriScore,
    ListItem,
    RateStar,
    Price,
    Button,
    CarteKdoMontant,
    Titre,
    Badge,
    LazyImage,
    BadgePoids,
    Divider,
    EnergyClass,
    PopinTraiteurDeFetes,
    PopinTraiteurPermanent,
    ProductDetailsVariant,
    ItemContainer,
    ShippingMethodEligibility,
    ImageProductViewer,
    AdvantagesContainer,
    IndiceReparabilite,
    BandeauTraiteurFete,
    BandeauTraiteurPermanent,
    ReassuranceDLC,
    Popin,
    ButtonIcon,
    Alert,
    CmsFetcher,
    ProductDetailsMultipay,
    PrixRemise,
    BadgeBoutique
  },
  props: {
    ...productDetailsProps()
  },
  emits: ["openOrcloseStoreLocator", ...productDetailsEmits()],
  setup(props, context) {
    const { parentLevel } = useProductSheetBreadcrumb(props);
    const popinContent = ref(null);
    const labelInfos = ref(null);

    const {
      showPlanningClickCollectTraiteur,
      showPlanningClickCollectTraiteurNoel,
      AddToPurchaseList,
      dpClickAndCollectTraiteurUrl,
      dpClickAndCollectTraiteurNoelUrl,
      isPft,
      amount,
      discountedAmount,
      discountRate,
      pricePerUnit,
      uniteRef,
      characteristicsStickers,
      isClickAndCollectTraiteur,
      isClickAndCollectTraiteurNoel,
      isLdd,
      variantEnStock,
      isNotEligibleClickAndCollect,
      isNotEligibleLdd,
      showShippingMethodEligibility,
      indexPoidsChanged,
      formattedPrice,
      getNutriScoreClassName,
      url,
      trackingCtaMarque,
      variantCodes,
      productDetailsCodes,
      commercialStickerCodes,
      prixCKDO,
      isCarteKdo,
      isBuffet,
      getIconPrime,
      isMardiPass,
      isPrimeMarche,
      isPrimeBio
    } = useProductDetails(props, context);

    const { hasUnitReference, hasInfoConso, showProductBadge } =
      useProductListItem({
        article: props.product,
        isNational: props.isNational
      });

    const AddToCart = defineAsyncComponent(() =>
      import("@/components/organisms/product-sheet/add-to-cart/mobile")
    );
    const ProductAdvantages = defineAsyncComponent(() =>
      import("@/components/organisms/product-sheet/product-advantages")
    );
    return {
      showProductBadge,
      hasInfoConso,
      hasUnitReference,
      ProductAdvantages,
      AddToCart,
      parentLevel,
      showPlanningClickCollectTraiteur,
      showPlanningClickCollectTraiteurNoel,
      AddToPurchaseList,
      dpClickAndCollectTraiteurUrl,
      dpClickAndCollectTraiteurNoelUrl,
      isPft,
      amount,
      discountedAmount,
      discountRate,
      pricePerUnit,
      uniteRef,
      characteristicsStickers,
      isClickAndCollectTraiteur,
      isClickAndCollectTraiteurNoel,
      isLdd,
      variantEnStock,
      isNotEligibleClickAndCollect,
      isNotEligibleLdd,
      showShippingMethodEligibility,
      indexPoidsChanged,
      formattedPrice,
      getNutriScoreClassName,
      url,
      trackingCtaMarque,
      variantCodes,
      productDetailsCodes,
      commercialStickerCodes,
      alertShippingLad,
      primeEnergie,
      consigne,
      popinContent,
      labelInfos,
      prixCKDO,
      isCarteKdo,
      isBuffet,
      getIconPrime,
      isMardiPass,
      isPrimeMarche,
      isPrimeBio
    };
  },
  data() {
    return {
      productFeaturesCodes
    };
  },
  // a décommenter une fois qu'on recoit les notices
  // computed: {
  //   downloadFileLink() {
  //     let url = "";
  //     if (!this.product.attributes.is_variant) {
  //       const features = [...this.product.attributes.features];
  //       if (features.length > 0) {
  //         const caractersitics = features.find(
  //           e => e.type === productFeaturesCodes.CRACTERISTIQUES
  //         );
  //         const technicalCaracteristics =
  //           caractersitics &&
  //           caractersitics.groups &&
  //           caractersitics.groups.length > 0
  //             ? caractersitics.groups.find(
  //               e => e.code === productFeaturesCodes.TECHNICAL_CRACTERISTICS
  //             )
  //             : [];
  //         const downloadData =
  //           technicalCaracteristics &&
  //           technicalCaracteristics.values &&
  //           technicalCaracteristics.values.length > 0
  //             ? technicalCaracteristics.values.find(
  //               e => e.code === productFeaturesCodes.DOWNLOAD_NOTICE
  //             )
  //             : [];
  //         const notice =
  //           downloadData && downloadData.links && downloadData.links.length > 0
  //             ? downloadData.links.find(
  //               e => e.type === productFeaturesCodes.PDF
  //             )
  //             : "";
  //         url = notice.url;
  //       }
  //     }
  //     return url;
  //   }
  // },
  methods: {
    setPriceCkdo({ price, isInputtedPrice }) {
      this.prixCKDO = price;
      this.$nextTick(() => {
        this.$refs.itemContainer.setQuantity(
          1,
          null,
          isInputtedPrice ? "montant choisi" : "montant prédéfini"
        );
        this.prixCKDO = null;
      });
    },
    scrollTo(targetId) {
      const target = document.getElementById(targetId);
      if (!target) {
        return;
      }
      const targetOffsetTop = target.offsetTop;
      if (this.isPopin) {
        document.getElementById(targetId).scrollIntoView({
          left: 0,
          top: targetOffsetTop - 100
        });
      } else {
        window.scrollTo(0, targetOffsetTop - 100);
      }
    }
  }
};
</script>

<template>
  <div class="c-product-detail-mobile">
    <PopinTraiteurDeFetes
      :show-planning-click-collect-traiteur="showPlanningClickCollectTraiteurNoel"
      slide-up
      @closed="showPlanningClickCollectTraiteurNoel = false"
    />
    <PopinTraiteurPermanent
      :visible="showPlanningClickCollectTraiteur"
      slide-up
      @closed="showPlanningClickCollectTraiteur = false"
    />

    <div class="u-flex u-flex-column">
      <ImageProductViewer
        v-if="product.attributes.photos && product.attributes.photos.length > 0"
        :images="photos"
        :product-name="product.attributes.designation"
        :picto-principal="product.attributes.picto_principal"
        class="c-product-detail-mobile__image"
      />

      <div>
        <div
          v-if="showProductBadge && product.attributes.type !== 'CKDO'"
          class="u-mb-sm u-flex u-flex-wrap u-gap-xxs"
        >
          <BadgeBoutique
            :article="product"
            :url="firstLevelBreadcrumb ? firstLevelBreadcrumb.route : null"
            is-fp
          />
        </div>
        <div class="c-product-detail-mobile__top">
          <component
            :is="product.attributes.url_marque ? 'LinkTo' : 'div'"
            v-if="
              product.attributes.marque &&
                product.attributes.marque !== productDetailsCodes.SANS_MARQUE
            "
            :href="product.attributes.url_marque"
            class="c-product-detail-mobile__brand"
            @click="trackingCtaMarque()"
          >
            {{ product.attributes.marque }}
          </component>
        </div>
        <h1
          v-if="product.attributes.designation"
          class="u-font-22 u-font-700 u-mb-sm"
        >
          {{ product.attributes.designation }}
        </h1>

        <div class="u-flex u-flex-wrap u-gap-sm">
          <BadgePoids
            :article="product"
            :has-unit-reference="hasUnitReference"
            :has-info-conso="hasInfoConso"
          />
          <RateStar
            v-if="product.attributes.reviews_count > 0"
            :id="product.id"
            :score="parseFloat(product.attributes.review_rate)"
            :max="5"
            :count="product.attributes.reviews_count"
            disable-score
            icon-size="xs"
            class="c-product-detail-mobile__rate-star"
            @click="scrollTo('avis-clients')"
          />
        </div>
        <Alert
          v-if="product.attributes.infos_vendeur"
          class="u-mt-md u-mb-sm"
        >
          <div class="u-flex u-flex-column u-flex-align-center u-text-center">
            <div class="u-mr-sm">
              <LazyImage
                :src="
                  alertShippingLad
                "
                class="u-flex-shrink-none"
                height="40"
                width="40"
                alt=""
              />
            </div>
            <div class="u-pt-xs">
              <p class="u-font-500 u-font-17 u-mb-xs">
                Disponible uniquement à la<br />livraison à domicile
              </p>
              <p>
                Livraison sous
                {{ product.attributes.infos_vendeur.delai_livraison }} jours
                ouvrés à compter de la validation de votre commande
              </p>
              <Button
                link
                variant="primary"
                class="u-mt-xs"
                @click="$refs.alertShipping.show()"
              >
                Voir les conditions particulières de livraison
              </Button>
              <Popin
                ref="alertShipping"
                slide-up
              >
                <p class="u-font-secondary u-font-16 u-font-700 u-mb-xs">
                  Conditions particulières de livraison
                </p>
                <p class="u-font-14">
                  {{ product.attributes.infos_vendeur.conditions_livraison }}
                </p>
              </Popin>
            </div>
            <Button
              link
              variant="primary"
              class="u-mt-xs"
              @click="$refs.lddInfoPopin.show()"
            >
              En savoir plus
            </Button>
            <Popin
              ref="lddInfoPopin"
              slide-up
              aria-label="Informations LDD"
            >
              <CmsFetcher link="/infos-et-services/sinformer/exclus-web" />
            </Popin>
          </div>
        </Alert>
        <template v-if="product.attributes.prime_energie">
          <Divider dotted />
          <div class="c-product-detail-mobile__prime-energie u-mt-md">
            <LazyImage
              :src="primeEnergie"
              width="80"
              alt="Cora Prime Energie"
              class="u-flex-shrink-none"
            />
            <div class="c-product-detail-mobile__prime-energie-text">
              <p>Produit éligible à la prime<br>énergie cora</p>
              <LinkTo
                v-if="product.attributes.prime_energie.prime_energie_lien"
                :href="product.attributes.prime_energie.prime_energie_lien"
                variant="primary"
                target="_blank"
                size="sm"
                class="u-mt-xxs"
              >
                En savoir plus
                <Icon
                  name="external"
                  variant="primary"
                  size="xs"
                  class="u-ml-xxs u-flex-shrink-none"
                />
              </LinkTo>
            </div>
          </div>
          <div class="u-mt-md u-mb-sm">
            <p class="u-font-15">
              {{ product.attributes.prime_energie.bonus_ecologique_texte }}
            </p>
            <LinkTo
              v-if="product.attributes.prime_energie.bonus_ecologique_lien"
              variant="grey-1"
              size="md"
              target="_blank"
              :href="product.attributes.prime_energie.bonus_ecologique_lien"
            >
              Conditions sur le site du ministère de l'économie
            </LinkTo>
          </div>
          <Divider dotted />
        </template>
        <ShippingMethodEligibility
          v-if="showShippingMethodEligibility"
          :unavailable-services="product.attributes.unavailable_services"
          :jours-retraits="product.attributes.jours_retraits"
          infobulle
          popin-size="xs"
          class="c-product-detail-mobile__shipping"
        />
        <BandeauTraiteurFete
          v-if="isClickAndCollectTraiteurNoel"
          class="u-mt-sm u-mb-lg"
          @click="showPlanningClickCollectTraiteurNoel = true"
        />
        <BandeauTraiteurPermanent
          v-if="isClickAndCollectTraiteur"
          class="u-mt-sm u-mb-lg"
          @click="showPlanningClickCollectTraiteur = true"
        />
        <div class="u-mt-sm">
          <EnergyClass
            v-if="product.attributes.classe_energetique !== null"
            :classe-energetique="product.attributes.classe_energetique"
            show-link
          />
          <div>
            <IndiceReparabilite
              v-if="
                product.attributes.indice_reparabilite &&
                  product.attributes.indice_reparabilite.value
              "
              class="u-mt-md u-mb-md"
              :score="product.attributes.indice_reparabilite.value"
              :pdf="product.attributes.indice_reparabilite.url"
            />
          </div>
          <template v-if="!product.attributes.is_variant && product.attributes.product_list_item_features.length > 0">
            <p class="u-mt-md u-mb-xs u-font-700">
              Points forts
            </p>
            <List class="c-product-detail-mobile__features">
              <template
                v-for="(feature, i) in product.attributes.product_list_item_features"
                :key="feature.label"
              >
                <ListItem
                  v-if="i < 6"
                  class="c-product-detail-mobile__feature"
                >
                  {{ feature.label }} : {{ feature.value }}
                </ListItem>
              </template>
            </List>
          </template>
        </div>

        <ProductDetailsVariant
          v-if="variantEnStock && product.attributes.type === variantCodes.TC"
          :product-info="product.attributes"
        />

        <div
          v-if="isPrimeMarche || isPrimeBio || isMardiPass"
          class="c-product-avantage-encart"
        >
          <div class="u-flex u-flex-align-center u-mb-xs">
            <Icon
              :name="getIconPrime"
              size="md"
              class="u-mr-xs"
            />
            <Titre
              tag="h1"
              size="sm"
            >
              <template v-if="isMardiPass">
                -15% Mardi PASS
              </template>
              <template v-else-if="isPrimeMarche || isPrimeBio">
                -10% CLUB
              </template>
            </Titre>
          </div>
          <p>
            <template v-if="isMardiPass">
              15% cagnottés sur tous les produits de marques Carrefour pour toute commande passée pendant la Journée PASS de votre magasin en payant avec votre Carte PASS !
            </template>
            <template v-else-if="isPrimeMarche">
              -10% tous les jours sur tous les Fruits et Légumes ou -15% en payant avec la carte PASS. Avantage à activer dans votre espace “Mon Club Carrefour”
            </template>
            <template v-else-if="isPrimeBio">
              -10% tous les jours sur tous les produits Carrefour Bio ou -15% en payant avec la carte PASS. Avantage à activer dans votre espace “Mon Club Carrefour”
            </template>
          </p>

          <LinkTo
            v-if="!isMardiPass"
            class="u-mt-xs u-color-primary"
            to="https://www.carrefour.fr/mon-compte/fidelite/mes-primes"
            target="_blank"
            variant="primary"
            no-underline
          >
            Activez vos avantages
          </LinkTo>
        </div>

        <div class="c-product-detail-mobile__detail">
          <div
            v-if="
              isNational &&
                (!product.attributes.prix ||
                  product.attributes.prix == null ||
                  product.attributes.prix === '0.00')
            "
            class="c-product-detail-mobile__store-availability"
          >
            <p
              v-if="!product.attributes.produit_non_vendable"
              class="c-product-detail-mobile__store-availability-text"
            >
              Consultez la disponibilité et le prix de ce produit dans le
              magasin le plus proche de chez vous.
            </p>
            <div
              v-if="!product.attributes.produit_non_vendable"
              class="c-product-detail-mobile__store-availability-buttons"
            >
              <client-only>
                <ItemContainer
                  :article="product"
                  :component="AddToPurchaseList"
                  :from-prospectus="fromProspectus"
                />
              </client-only>
              <div class="u-flex-item-fluid"></div>
              <Button
                variant="primary"
                radius="full"
                size="sm"
                @click="$emit('openOrcloseStoreLocator')"
              >
                Choisir un magasin
              </Button>
            </div>
          </div>
          <div
            v-else-if="
              (!isNational && !product.attributes.en_stock) ||
                isNotEligibleClickAndCollect ||
                isNotEligibleLdd ||
                isReplacedByNational
            "
            class="c-product-detail-mobile__store-availability"
          >
            <p class="c-product-detail-mobile__store-availability-text">
              <template v-if="isReplacedByNational">
                Ce produit n'est pas disponible dans votre magasin
              </template>
              <template v-else>
                Ce produit sera bientôt disponible
              </template>
            </p>
            <div class="c-product-detail-mobile__store-availability-buttons c-product-detail-mobile__store-availability-buttons--centered">
              <client-only v-if="!isCarteKdo">
                <ItemContainer
                  :article="product"
                  :component="AddToPurchaseList"
                  :from-prospectus="fromProspectus"
                />
              </client-only>
              <div class="u-flex-item-fluid"></div>
              <Button
                :to="parentLevel"
                variant="primary"
                radius="full"
                size="md"
              >
                Voir les produits similaires
              </Button>
            </div>
            <p class="u-text-center u-mt-md">
              <Button
                link
                class="c-product-detail-mobile__store-availability-link"
                @click="$emit('openOrcloseStoreLocator')"
              >
                Acheter dans un autre magasin
              </Button>
            </p>
          </div>
          <template v-else-if="product.attributes.prix > 0">
            <Divider
              v-if="
                product.attributes.prix &&
                  product.attributes.avantages &&
                  product.attributes.avantages.length > 0
              "
              dotted
            />
            <AdvantagesContainer
              v-if="
                product.attributes.avantages !== null &&
                  product.attributes.avantages.length > 0 &&
                  !isPro
              "
              :component="ProductAdvantages"
              :advantages="product.attributes.avantages"
              :article="product"
              :cart-context="trackingCodes.LABELGA.FP"
              :available-quantity="product.attributes.qte_max_panier - quantity"
              :max-lenght="16"
              class="c-product-detail-mobile__advantages"
            />

            <template v-if="isCarteKdo">
              <div class="c-product-detail-mobile__price-wrapper u-text-center">
                <Button
                  variant="secondary"
                  radius="full"
                  size="md"
                  @click="$refs.carteKdoMontantPopin.show()"
                >
                  J'offre cette carte
                </Button>
                <Popin
                  ref="carteKdoMontantPopin"
                  slide-up
                >
                  <Titre
                    tag="p"
                    class="u-mb-md"
                  >
                    {{ product.attributes.designation }}
                  </Titre>
                  <CarteKdoMontant
                    ref="ckdoForm"
                    gellule-size="xs"
                    :product="product"
                    @setPrice="setPriceCkdo"
                  />
                  <div class="u-mt-md u-flex u-flex-justify-center">
                    <ItemContainer
                      ref="itemContainer"
                      v-if="
                    !product.attributes.produit_non_vendable &&
                      !isReplacedByNational
                  "
                      :component="AddToCart"
                      :article="product"
                      :is-ckdo="isCarteKdo"
                      :prix="prixCKDO"
                      :cart-context="trackingCodes.LABELGA.FP"
                      :pft-conf="product.attributes.pft_conf"
                      :is-pft="isPft"
                      :max-cart-qty="product.attributes.qte_max_panier"
                      :from-prospectus="fromProspectus"
                      @indexPoidsChanged="indexPoidsChanged"
                      @addToCart="$refs.ckdoForm.validate()"
                    />
                  </div>
                </Popin>
              </div>
            </template>
            <div
              v-else
              class="c-product-detail-mobile__price-wrapper"
            >
              <Price
                v-if="product.attributes.prix"
                :amount="amount"
                :discount-rate="!isNational ? discountRate : null"
                :crossed-out-amount="
                  !isNational ? formattedPrice(discountedAmount) : null
                "
                :prix-remise="product.attributes.prix_avec_remise_sans_appel_fidelite"
                :price-unit-reference="pricePerUnit"
                :reference-unit="uniteRef"
                :is-flex="!isNational && !!discountRate && !product.attributes.prix_avec_remise_sans_appel_fidelite"
                :is-buffet="isBuffet"
                spinner-type="spinnerType"
                size="xxlg"
                class="u-flex u-flex-column u-flex-align-end"
              />
              <p
                v-if="product.attributes.eco_part"
                class="c-product-detail-mobile__unitPrice"
              >
                dont {{ formatPrix(product.attributes.eco_part) }}&nbsp;€ d'éco-part
              </p>
              <p
                v-if="product.attributes.eco_mobilier"
                class="c-product-detail-mobile__unitPrice"
              >
                dont {{ formatPrix(product.attributes.eco_mobilier) }}&nbsp;€
                d'éco-mobilier
              </p>
              <p
                v-if="isLdd"
                class="c-product-detail-mobile__shipping-cost"
              >
                frais de livraison inclus
              </p>
              <ProductDetailsMultipay
                v-if="product.attributes.eligible_fullcb"
                :product="product"
              />
              <client-only>
                <ItemContainer
                  v-if="
                    !product.attributes.produit_non_vendable &&
                      !isReplacedByNational
                  "
                  :component="AddToCart"
                  :article="product"
                  :is-buffet="isBuffet"
                  :prix="prixCKDO"
                  :cart-context="trackingCodes.LABELGA.FP"
                  :pft-conf="product.attributes.pft_conf"
                  :is-pft="isPft"
                  :max-cart-qty="product.attributes.qte_max_panier"
                  :from-prospectus="fromProspectus"
                  @indexPoidsChanged="indexPoidsChanged"
                />
              </client-only>
              <div
                v-if="
                  product.attributes.produit_non_vendable &&
                    product.attributes.en_stock
                "
                class="u-text-center u-mt-xs"
              >
                <p class="u-font-500 u-font-15 u-mb-sm u-mb-xs">
                  <template v-if="isNational">
                    Ce produit est disponible uniquement en magasin
                  </template>
                  <template v-else>
                    Pour acheter cet article, rendez-vous dans votre magasin de
                    {{ shopName }}
                  </template>
                </p>
                <div>
                  <Button
                    v-if="isNational"
                    variant="primary"
                    radius="full"
                    size="sm"
                    @click="$emit('openOrcloseStoreLocator')"
                  >
                    Voir les magasins proposant ce produit
                  </Button>
                  <Button
                    v-else
                    variant="primary"
                    radius="full"
                    size="sm"
                    :to="`/magasins/${aliasWeb}-m-${shopId}`"
                  >
                    Voir la fiche magasin
                  </Button>
                </div>
                <div
                  v-if="!isNational"
                  class="u-mt-xs"
                >
                  <Button
                    link
                    variant="primary"
                    @click="$emit('openOrcloseStoreLocator')"
                  >
                    Acheter dans un autre magasin
                  </Button>
                </div>
              </div>
            </div>
          </template>
        </div>
        <Divider
          v-if="!isNational && product.attributes.origine"
          dotted
        />
        <div
          v-if="!isNational && product.attributes.origine"
          class="c-product-detail-mobile__line"
        >
          <Badge class="c-product-detail-mobile__origin-sticker">
            <span>{{ product.attributes.origine }}</span>
          </Badge>
        </div>
        <div class="c-product-detail-mobile__line">
          <div
            v-if="product.attributes.with_consigne"
            class="c-product-detail-mobile__gas u-mt-xs"
          >
            <LazyImage
              :src="consigne"
              class="c-product-list-item-grid__sticker"
              width="120"
              alt=""
            />
            <p class="c-product-detail-mobile__gas-text">
              Pensez à ramener votre consigne vide pour l’échange de la
              bouteille
            </p>
          </div>
          <template v-else>
            <Popin
              ref="labelInfos"
              slide-up
              size="md"
            >
              {{ popinContent.alt }}
            </Popin>
            <List
              v-if="characteristicsStickers"
              class="c-product-detail-mobile__stickers"
            >
              <template
                v-for="picto in characteristicsStickers"
                :key="picto.alt"
              >
                <ListItem
                  v-if="picto.code && url(picto.code)"
                  class="c-product-detail-mobile__sticker"
                >
                  <Button @click="
                popinContent = picto;
                labelInfos.show();
              ">
                    <LazyImage
                      :src="url(picto.code)"
                      :alt="picto.alt"
                      class="c-product-list-item-grid__sticker"
                      height="32"
                      width="32"
                    />
                  </Button>

                </ListItem>
              </template>
            </List>
            <template v-if="product.attributes.nutriscore !== null">
              <Divider
                v-if="
                  (characteristicsStickers &&
                    characteristicsStickers.length > 0) ||
                    product.attributes.origine
                "
                vertical
                class="c-product-detail-mobile__line-divider u-m-none"
              />
              <NutriScore
                :alt="product.attributes.nutriscore.alt"
                :class="getNutriScoreClassName()"
                :context="'mobile'"
              />
            </template>
          </template>
        </div>
        <ButtonIcon
          v-if="product.attributes.is_porteur_dlc"
          icon-name="info-circle"
          link
          variant="primary"
          icon-color="primary-light"
          icon-color-hover="primary-light"
          icon-size="xs"
          class="u-mt-xs"
          @click="$refs.popinDLC.show()"
        >
          Voir les dates limites de consommation garanties
        </ButtonIcon>
      </div>
    </div>
    <Popin
      v-if="product.attributes.is_porteur_dlc"
      ref="popinDLC"
      page-back
      aria-label="Date limite de consommation"
    >
      <ReassuranceDLC />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/product-details-mobile.scss";
</style>
